<template>
    <div>
        <el-form :inline="true" label-width="100px" :model="invoiceExtractData" class="demo-form-inline dis" size="mini">
            <el-row>
                <el-form-item label="通用名称">
                    <label slot="label" :style="$common.labelStyle('通用名称')" v-html="'通用名称'"></label>
                    <el-input clearable v-model="getRequestData.bgmName" class="form_codition"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" @click="getList()" type="primary">查询</el-button>
                    <el-button size="mini" :disabled="returnObj.mainData.length==0" @click="sureDetail()" type="primary">确定选择</el-button>
                </el-form-item>
            </el-row>
        </el-form>
        <!-- 表格 -->
        <el-table ref="moviesTable" :data="mainData" height="360" size="mini" style="width: 100%" border stripe highlight-current-row @row-dblclick="dblclick" @selection-change="mainSelectionChange">
            <el-table-column type="selection" width="50" :selectable="selectEnable"></el-table-column>
            <el-table-column align="center" min-width="120" prop="bgmCode" label="商品编号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="bgmName" label="通用名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="bgpUnitmeasurement" label="包装单位" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessId" label="业务单号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessNum" label="业务数量" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessType" label="业务类型" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessType" label="业务类型" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="150" prop="createTime" label="日期" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.createTime">{{ $common.getLocalTime(scope.row.createTime) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" min-width="150" prop="expidate" label="失效日期" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.expidate">{{ $common.getLocalTime(scope.row.expidate) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" min-width="120" prop="inRate" label="进项税率" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="lotno" label="批次号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="money" label="金额" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="price" label="价格" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="prodate" label="生产日期" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.prodate">{{ $common.getLocalTime(scope.row.prodate) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" min-width="120" prop="psmoney" label="含税金额" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="psprice" label="含税价格" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="recPnumber" label="对账数量" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="sterBatchno" label="灭菌批号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="taxAmount" label="税额" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="udiCode" label="UDI" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="xlh" label="序列号" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="getRequestData.page" :page-sizes="pageSizes" background :page-size="getRequestData.rows"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "extractConsignmentReconciliation",
    components: {},
    data() {
        return {
            ormId: "",
            pageSizes: [30, 100, 200, 300],
            total: 0,
            mainData: [],
            isPagination: "",
            returnObj: {//外层对象数据
                mainData: [],
            },
            seWidth: "",
            exWidth: "",
            seTitle: "",
            DialogVisible: false,
            parentSearchData: {},
            getRequestData: {
                page: 1,
                rows: 30,
                end: "",
                start: "",
                coId: "",
                smId: "",
                bgmName: "",
            }
        };
    },

    props: {
        invoiceExtractData: {
            type: Object,
            require: true
        },
        parentData: {//选中的数据
            type: Object,
            require: false
        },
    },
    watch: {},
    computed: {},
    mounted() { },
    created() {
        this.getTableMainList()
    },
    methods: {
        //默认勾选禁用状态
        selectEnable(row, rowIndex) {
            if (this.parentData && this.parentData.list.length > 0) {
                var flag = false
                this.parentData.list.forEach(item => {
                    if (row[this.parentData.type] == item[this.parentData.type]) {
                        flag = true
                    }
                })
                if (flag) {
                    return false
                }
            }
            return true
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'smName') this.parentSearchData.smId = val.smId
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, val[item])
            })
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {

            this.DialogVisible = true
            this.seType = type
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },

        //主单选择
        mainSelectionChange(val) {
            this.returnObj.mainData = val
            if (this.parentData && this.parentData.list.length > 0) {
                this.mainData.forEach(item => {
                    this.parentData.list.forEach(item1 => {
                        if (item[this.parentData.type] == item1[this.parentData.type]) {
                            this.$refs.moviesTable.toggleRowSelection(item, true);
                        }
                    })
                })
                if (this.returnObj.mainData.length > 0) {
                    this.parentData.list.forEach(item1 => {
                        this.returnObj.mainData.forEach((item, index) => {
                            if (item[this.parentData.type] == item1[this.parentData.type]) {
                                this.returnObj.mainData.splice(index, 1)
                            }
                        })
                    })
                    this.returnObj.mainData = this.returnObj.mainData.concat(this.parentData.list)
                } else {
                    this.returnObj.mainData = this.parentData.list
                }
            }
        },
        dblclick(row) {
            var flag = false
            this.returnObj.mainData.forEach((item, index) => {
                if (item.businessId == row.businessId && !flag) {
                    flag = true
                    this.$refs.moviesTable.toggleRowSelection(row, false)
                    this.returnObj.mainData.splice(index, 1)
                }
            })
            if (!flag) {
                this.$refs.moviesTable.toggleRowSelection(row, true)
                this.returnObj.mainData.push(row)
            }
        },
        //确认选择
        sureDetail() {
            this.$emit("invoiceExtractMethods", this.returnObj);
        },
        getList() {//查询
            this.getRequestData.page = 1
            this.getTableMainList()
        },
        // 获取主表格
        async getTableMainList() {
            Object.assign(this.getRequestData, this.invoiceExtractData)
            let res = await this.$http.reconciliationextPisInfo(this.getRequestData)
            if (res && res.status == 200) {
                this.mainData = res.result.list; //默认第一条
                this.total = res.result.total
                if (this.parentData && this.parentData.list.length > 0) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.mainData.forEach(item => {
                                this.parentData.list.forEach(item1 => {
                                    if (item[this.parentData.type] == item1[this.parentData.type]) {
                                        this.$refs.moviesTable.toggleRowSelection(item, true);
                                    }
                                })
                            })
                            this.returnObj.mainData = this.parentData.list
                            this.$nextTick(() => {
                                this.$refs.moviesTable.doLayout();
                            })
                        }, 100)
                    })
                }
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
                this.$emit("invoiceExtractMethods", '')
                return false
            }
        },
        //分页
        handleSizeChange(val) {
            this.getRequestData.rows = val;
            this.getTableMainList();
        },
        // 分页
        handleCurrentChange(val) {
            this.getRequestData.page = val;
            this.getTableMainList();
        },
    },
};
</script>

<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}
</style>
